<template>
    <ValidationObserver :ref="stepName" v-slot="observer">

        <div v-for="(field,name) in fields" :key="name" class="field-container">
            <component :is="field._component" :key="name" :name="name" :field="field" :step="step"></component>
        </div>
        <b-button type="button is-primary next-button" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>


    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import {Text} from "../../../../../../models/fields/Text";
import {Select} from "../../../../../../models/fields/Select";
import {Option} from "../../../../../../models/fields/Features/Option";
import {Button} from "../../../../../../models/fields/Button";

export default {
    mixins: [mixin,form_step_mixin],
    data() {
        return {
            fields: {
                gender: new Select().required()
                    .addOptions([
                        new Option('De heer', 'm'),
                        new Option('Mevrouw', 'f'),
                    ]),
                firstname: new Text().label('Voornaam').placeholder('vb. Veerle').required().validation({max:40, name: true}),
                lastname:new Text().label('Achternaam').placeholder('vb. Janssens').required().validation({max:40, name: true}),
            }
        }
    },
    mounted() {
        if(this.$store.get('form_data/gender') === null) {
            this.$store.set('form_data/gender', 'm')
        }
    }
}
</script>
